export const ButtonTooltipContainerDefProps = {
  children: 'ButtonTooltipContainer',
  tooltipPosition: 'top',
  tooltipContent: 'tooltip'
};